import axiosInstance from "../interceptor/instance";
import axiosMapInstance from "../interceptor/webMapInstance";

export const capacityURL = `${process.env.REACT_APP_BASE_URL_WEB_MAP}/capacity`;

export const getQueryParams = (query, bbox, page = null, pageSize = null, filterLvl = null, subLvl = false) => {
  const { year, operator, month, enodbID, secID, flag, action, northEast, southWest, searchVal} = query
  const queryParams = {month, year, flag, operator, action, searchVal, northEast, southWest, page,  limit: pageSize,  filterLvl}
  let urlParam = `${query.countryCode}${!bbox && query.level && query.levelVal ? "/" + query.level + "/" + query.levelVal : ""}?`
  Object.keys(queryParams).forEach((key) => {
    if (queryParams[key]) {
      urlParam += `&${key}=${queryParams[key]}`;
    }
  });
  if(!subLvl && enodbID){
    urlParam += `&enodbID=${enodbID}`
  }
  if(!subLvl && secID){
    urlParam += `&secID=${secID}`
  }
  if(!filterLvl){
    urlParam += `&clearCacheEntry=${bbox}`
  }
  return urlParam
}

export const getAdvancedCapacityData = async(query) => {
  let advanceUrl = getQueryParams(query, false, query?.pageNum, query?.pageLimit,1)
  const advanceSearchKeys = query?.advanceSearchKeys?.length ? encodeURIComponent(JSON.stringify(query?.advanceSearchKeys)) : []
  const sortParameters = query?.sortParams?.length ? encodeURIComponent(JSON.stringify(query?.sortParams)) : []
  advanceUrl += `&searchFilters=${advanceSearchKeys}`
  advanceUrl += `&sortParams=${sortParameters}`
  const response = await axiosMapInstance.get(`${capacityURL}/advanceSearch/${advanceUrl}`)
  return response?.data
}

export const getCapacityChartData = async (data) => {
  const chartUrl = getQueryParams(data, false)
  const response = await axiosInstance.get(`${capacityURL}/chart/${chartUrl}`);
  return response?.data;
};

export const getCapacityFilters = async (query,bbox = false,cancelToken,pageSize,page) => {
  const baseFilterUrl = getQueryParams(query, bbox,page, pageSize, query?.filterLvl )
  const instance = query?.filterLvl === 'year' || query?.filterLvl === 'month' ? axiosMapInstance :  axiosInstance
  const response =  await instance.get(`${capacityURL}/filters/${baseFilterUrl}`)
  return response.data
};

export const getCapacitySubFilters = async (query,bbox = false,cancelToken,pageSize,page) => {
  let subFilterUrl = getQueryParams(query, bbox,page, pageSize, query?.filterLvl,true )
  if(query?.secID?.length){
   subFilterUrl += `&secID=${encodeURIComponent(JSON.stringify(query?.secID))}`
  }
  if(query?.enodbID?.length){
    subFilterUrl += `&enodbID=${encodeURIComponent(JSON.stringify(query?.enodbID))}`
  }
  const response = await axiosInstance.get(`${capacityURL}/subFilters/${subFilterUrl}`);
  return response.data
};

export const getCapacityAdvancedTableFilters = async (qry) => {
  const response = await axiosMapInstance.get(`${capacityURL}/filter/advancedTable/options/${qry.country}?year=${qry.year}&month=${qry.month}&operator=${qry.op}`);
  return response?.data;
}